import { DIFF_TYPES } from "../../context/utils/getCalculatedState";

/**
 * Generates summary statistics from changelog diff data
 * @param {Object} teams - Teams with diff data
 * @param {Object} members - Members with diff data
 * @returns {Object} Summary object with counts by change type
 */
export const generateChangelogSummary = (teams = {}, members = {}) => {
  const summary = {
    teams: {
      added: 0,
      removed: 0,
      moved: 0,
    },
    members: {
      new: 0,
      removed: 0,
      moved: 0,
    },
    allocations: {
      changed: 0,
    },
    attributes: {
      changed: 0,
    },
    tags: {
      changed: 0,
    },
  };

  // Track entities that have been counted for moves to avoid double-counting
  // MOVED events come as pairs (MOVED_OUT + MOVED_IN) for a single move
  const teamMovesTracked = new Set();
  const memberMovesTracked = new Set();

  // Process team changes
  Object.values(teams).forEach((team) => {
    if (!team.diff) {
      return;
    }

    Object.values(team.diff).forEach((diffEntry) => {
      const diffType = diffEntry._type;
      if (diffType === DIFF_TYPES.ADDED) {
        summary.teams.added += 1;
      } else if (diffType === DIFF_TYPES.REMOVED) {
        summary.teams.removed += 1;
      } else if (
        diffType === DIFF_TYPES.MOVED_IN ||
        diffType === DIFF_TYPES.MOVED_OUT
      ) {
        // Only count each move once - MOVED_IN and MOVED_OUT are paired events
        if (!teamMovesTracked.has(team.id)) {
          summary.teams.moved += 1;
          teamMovesTracked.add(team.id);
        }
      }
    });
  });

  // Process member changes
  Object.values(members).forEach((member) => {
    if (!member.diff) {
      return;
    }

    Object.values(member.diff).forEach((diffEntry) => {
      const diffType = diffEntry._type;
      if (diffType === DIFF_TYPES.NEW) {
        summary.members.new += 1;
      } else if (diffType === DIFF_TYPES.REMOVED) {
        summary.members.removed += 1;
      } else if (
        diffType === DIFF_TYPES.MOVED_IN ||
        diffType === DIFF_TYPES.MOVED_OUT
      ) {
        // Only count each move once - MOVED_IN and MOVED_OUT are paired events
        if (!memberMovesTracked.has(member.id)) {
          summary.members.moved += 1;
          memberMovesTracked.add(member.id);
        }
      }
    });
  });

  // Note: Allocation, attribute, and tag changes will be detected
  // in processChangelogData function by comparing baseline vs next data
  // This summary will be updated there

  return summary;
};
